import { BitfSortApiRequestPart } from '@bitf/core/api-call-state/bitf-sort-api-request-part.builder';

export class BitfGraphQlSortApiRequestPart extends BitfSortApiRequestPart {
  constructor(params) {
    super(params);
  }
}
